import React from 'react';

import SettingsPage from 'Pages/Settings/SettingsPage';

import Table from 'Components/HumanResources/Timesheets/Table';

export default class TimeWorked extends React.Component {
    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        return (
            <SettingsPage>
                <Table
                    type='time_worked'
                    title={'My HR ' + window.base.hr_timesheet_types['time_worked']?.label}
                    admin={false}
                />
            </SettingsPage>
        );
    }
}
